import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import img from '../../assets/img/concours.png'
import BlackLogo from '../../components/BlackLogo'
import Input from '../../components/Input'
import LoadingSpinner from '../../components/LoadingSpinner.js'
import saveGuessCustomerPublic from '../../utility/saveGuessCustomerPublic'

const ConcoursForm = () => {
	const { customerId } = useParams()
	const [isLoading, setIsLoading] = useState(false)
	const [guess, setGuess] = useState('0-2kg')

	const navigate = useNavigate()

	const inputChangeHandler = (changeEvent) => {
		setGuess(changeEvent.target.value)
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		if (guess) {
			setIsLoading(true)
			try {
				const updated = await saveGuessCustomerPublic(customerId, guess)
				if (updated) {
					navigate('/concours-confirmation')
				} else {
					console.error("La mise à jour du client n'a pas fonctionnée.")
				}
			} catch (error) {
				console.error('Error saving guess:', error)
			}
			setIsLoading(false)
		}
	}
	return (
		<div className="mobile-screen-wrapper">
			<form onSubmit={handleSubmit} className="wrapper wrapper-inner">
				<div className="gap-border mb-3"></div>
				<h2 className="mb-3 pt-1" style={{ lineHeight: '1' }}>
					Concours
				</h2>
				<div className="subtitle-1 mb-41">
					Répondez à une question et tentez de remporter un grille-pain de la
					marque Smeg !
				</div>
				<div className="text-center mb-5">
					<img src={img} alt="" />
				</div>
				<Input
					labelMedium
					label="Estimez le poids du grille pain :"
					id="Guess"
					onChange={(e) => inputChangeHandler(e)}
					required="required"
					placeholder="100g"
					type="text"
					select={selectData}
				/>
				<div className="__content-236 mt-auto mb-39px">
					{isLoading ? (
						<div className="cmn-btn w-100">
							<LoadingSpinner height="80%" width="30%" />
						</div>
					) : (
						<button className="cmn-btn w-100" type="submit">
							Valider
						</button>
					)}
				</div>
				<BlackLogo />
			</form>
		</div>
	)
}

const selectData = [
	{
		label: '0-2kg',
		value: '0-2kg',
	},
	{
		label: '2-3kg',
		value: '2-3kg',
	},
	{
		label: '3kg+',
		value: '3kg+',
	},
]

export default ConcoursForm
